import { getItemId } from '../../../../../util';
import React from 'react';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import * as toolSelectors from '../../../../../selectors/tools';
import { MultipleLineContainer } from '../../DTInfoWidget.styles';
import { TrackingLink } from './TrackingLink';

export const TrackingLinkOrInfo = (props) => {
  const { item } = props;
  const trackingStatusByItemId = useSelector(toolSelectors.getTrackingStatusByItemId);
  const orderingSystem = useSelector(toolSelectors.getOrderingSystem);
  const carrierAndTrackingNumberByItemId = useSelector(toolSelectors.getCarrierAndTrackingNumberByItemId);
  const itemId = getItemId(item, orderingSystem);
  const { carrier_code, tracking_number } = carrierAndTrackingNumberByItemId[itemId] || {}; // TODO Object.values(carrierAndTrackingNumberByItemId[itemId] || {}).split(" ");

  const getTrackingLinks = () => {
    switch (orderingSystem) {
      case 'common':
        // Items almost always have one shipment
        const trackingLinks = get(trackingStatusByItemId, `[${item.itemId}]`, []);

        return Array.isArray(trackingLinks) ? trackingLinks.map((status) => status?.trackingUrl) : [];
      case 'shopify':
        return get(trackingStatusByItemId, `[${item.id}]`, []).map((status) => status?.tracking_url);
      case 'salesforce':
        return [get(item, 'TrackingUrl', null)];
      case 'bigCommerce':
        return get(trackingStatusByItemId, `${item.id}`, []).map((status) => status?.tracking_link);
      default:
        return [];
    }
  };

  // filter out undefined items from array
  const trackingLinks = getTrackingLinks().filter(Boolean);
  if (trackingLinks.length) {
    return (
      <MultipleLineContainer>
        {trackingLinks.flat().map((trackingLink, i) => (
          <TrackingLink url={trackingLink} key={i} />
        ))}
      </MultipleLineContainer>
    );
  }
  if (carrier_code && tracking_number) {
    return (
      <span>
        {carrier_code} {tracking_number}
      </span>
    );
  } else if (tracking_number) {
    return <span>{tracking_number}</span>;
  }

  return '-';
};
